import BgRadial from "@/components/bg-radial/bg-radial";
import NewsCardSlider from "@/components/news-card/news-card-slider/news-card-slider";

const NewsContentSlider = ({
	news,
	newsActiveColor,
	setNewsActiveColor,
}: {
	news: any[];
	newsActiveColor: string;
	setNewsActiveColor: any;
}) => {
	if (news && news.length > 0) {
		return (
			<div className={"w-full relative py-[64px]"}>
				<BgRadial
					id={"games"}
					color={newsActiveColor}
					height={"80%"}
					width={"50%"}
					top={"20%"}
					bottom={"auto"}
				/>
				<h2 className="text-white font-bold my-[28px] text-right text-[32px] w-full">
					اخبار
				</h2>
				<NewsCardSlider
					setActiveColor={setNewsActiveColor}
					slides={news}
					id={"news-card-slider"}
					centeredSlides={false}
				/>
			</div>
		);
	}
};

export default NewsContentSlider;
